// copyright itestra GmbH 2016
import { Component, ChangeDetectionStrategy, Input } from "@angular/core";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";

import { Protocol, Offer, Division } from "../../data/model";
import { stateBuilder } from "../../store/utils";
import { RootState } from "../../store/root";
import { PersistenceService } from "../../store/model/persistence.service";

@Component({
    selector: "zbd-product-occasion",
    templateUrl: "product-occasion.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductOccasionComponent {
    @Input() protocol: Protocol;

    state$: Observable<LocalState>;

    constructor(
        public persistence: PersistenceService,
        store: Store<RootState>,
    ) {
        this.state$ = LocalState.create(store);
    }

    public getProductList(
        protocol: Protocol,
    ): { cat: string; prods: string[] }[] {
        const productMap: Record<string, Record<string, null>> = {};
        protocol.Offers.forEach((offer: Offer) => {
            offer.Divisions.forEach((division: Division) => {
                if (productMap[division.CategoryName]) {
                    productMap[division.CategoryName][division.Name] = null;
                } else {
                    productMap[division.CategoryName] = {
                        [division.Name]: null,
                    };
                }
            });
        });
        const productLists = [];
        for (const cat in productMap) {
            productLists.push({
                category: cat,
                products: Object.keys(productMap[cat]),
            });
        }
        return productLists;
    }
}

export class LocalState {
    protocol: Protocol;

    static create(store: Store<RootState>): Observable<LocalState> {
        return stateBuilder(store, new LocalState()).apply(
            "protocol",
            (s) => s.model.ConsultationProcess.Protocol,
        ).state$;
    }
}
